/**
 * Created by skz on 2017/10/10 14:03
 */

// ===================================
// =========== 首页模块 ===============
// =========== ------- ===============
// ----------- 乐生活-详情页---------------
// ===================================

import request from '../ajax';

/**
 * 向后台获取麻辣详情用户登录token
 * @param openToken
 */
export function fetchToken (openToken) {
    return request.post({
        reqMethod: 'account.access.getChildToken',
        params: {
            'openToken' : openToken
        }
    })
}

/**
 * 获取麻辣详情文本信息
 * @param magazineId
 */
export function fetchVoteContent (magazineId) {
    return request.post({
        reqMethod: 'popularize.magazine.getMagazineDetail',
        params: {
            'magazineId' : magazineId
        }
    })
}

/**
 * 获取麻辣详情用户头像
 * @param accessToken
 */
export function fetchUserPhoto (accessToken) {
    return request.post({
        reqMethod: 'utopa.user.getIndexUserDate',
        params: {
            'accessToken' : accessToken,
            "sysId" : 1
        }
    })
}

/**
 * 获取麻辣详情投票信息
 * @param magazineId
 */
export function fetchVoteData (magazineId,accessToken) {
    return request.post({
        reqMethod: 'popularize.magazine.getMagazineVote',
        params: {
            'magazineId': magazineId,
            'accessToken' : accessToken
        }
    })
}

/**
 * 麻辣详情投票接口
 * @param magazineId，voteOptionId
 */
export function goVote (obj) {
    return request.post({
        reqMethod: 'popularize.magazine.saveMagazineVote',
        params: {
            'magazineId': obj.magazineId,
            'voteOptionId': obj.voteOptionId,
            'accessToken' : obj.accessToken
        }
    })
}

/**
 * 获取麻辣详情精选评论
 * @param magazineId，magazineId
 */
export function fetchChoiceComments (magazineId,pageNo,pageSize,accessToken) {
    return request.post({
        reqMethod: 'popularize.magazine.getMagazineChosenComment',
        params: {
            'magazineId': magazineId,
            'pageNo' : pageNo,
            'pageSize' : pageSize,
            'accessToken' : accessToken
        }
    })
}

/**
 * 发表麻辣详情精选评论
 * @param magazineId，content
 */
export function postComment (magazineId,content,accessToken) {
    return request.post({
        reqMethod: 'popularize.magazine.saveMagazineComment',
        params: {
            'magazineId': magazineId,
            'content': content,
            'accessToken':accessToken
        }
    })
}

// ===================================
// =========== 首页模块 ===============
// =========== ------- ===============
// ----------- 乐生活-历史往期---------------
// ===================================

/**
 * 获取历史往期列表信息
 * @param tagId pageNo pageSize
 */
export function fetchPastList (tagId,pageNo,pageSize,mallId,type) {
    return request.post({
        reqMethod: 'popularize.magazine.getMagazineChildList',
        params: {
            'tagId' : type === 2? undefined : tagId,
            'pageNo' : pageNo,
            'pageSize' : pageSize,
            'mallId' : mallId,
            'type': type
        }
    })
}

// ===================================
// =========== 首页模块 ===============
// =========== ------- ===============
// ----------- 乐生活主页---------------
// ===================================

/**
 * 获取乐生活主页列表信息
 * @param
 */
export function fetchList (mallId) {
    return request.post({
        reqMethod: 'popularize.magazine.getMagazineList',
        params: {
            'mallId' : mallId
        }
    })
}

// ===================================
// =========== 首页模块 ===============
// =========== ------- ===============
// ----------- 商品列表 ---------------
// ===================================

/**
 * 获取商品列表主页列表信息
 * @param   mallId,saleWay,pageNo
 */
export function fetchVolumeList (mallId,saleWay,pageNo) {
    return request.post({
        reqMethod: 'eshop.goodsSaleWay.getGoodsList',
        params: {
            'mallId' : mallId,
            'saleWay' : saleWay,
            'pageNo' : pageNo,
            'pageSize' : 10
        }
    })
}


/**
 * 获取乐生活主页列表详情信息
 * @param
 */
export function fetchVolumeDetail (id,obj) {
    return request.post({
        reqMethod: 'eshop.goodsSaleWay.getGoods',
        params: {
            'shopGoodsId' : id,
            'longitude' : obj.longitude,
            'latitude' : obj.latitude,
        }
    })
}

/**
 * 获取优惠券评论
 * @param goodsId
 * 按照分享页需求只需要展示3条，这里只请求了3条数据
 */
export function fetchComment (goodsId,) {
    return request.post({
        reqMethod: 'eshop.goodsComments.selectByGoodsId',
        params: {
            'goodsId' : goodsId,
            'pageNo' : 1,
            'pageSize' : 3
        }
    })
}

// ===================================
// =========== 美食模块 ===============
// =========== ------- ===============
// ----------- 商铺详情 ---------------
// ===================================

/**
 * 获取店铺详情数据
 * @param shopId mallId  obj （经纬度）
 * 按照分享页需求只需要展示3条，这里只请求了3条数据
 */
export function fetchShopData (shopId,mallId,obj) {
    return request.post({
        reqMethod: 'eshop.shop.getShopDetail',
        params: {
            'shopId' : shopId,
            'mallId' : mallId,
            'lng' : obj.longitude,
            'lat' : obj.latitude
        }
    })
}

/**
 * 获取店铺详情数据
 * @param shopId mallId  obj （经纬度）
 * 按照分享页需求只需要展示3条，这里只请求了3条数据
 */
export function fetchShopComment (shopId) {

    return request.post({
        reqMethod: 'eshop.goodsComments.selectByShopId',
        params: {
            'shopId' : shopId,
            'pageNo' : 1,
            'pageSize' : 3
        }
    })
}

/**
 * 获取店铺详情数据
 * @param shopId mallId  obj （经纬度）
 * 按照分享页需求只需要展示3条，这里只请求了3条数据
 */
export function fetchGoodsList(mallId, saleWay, shopId) {

    return request.post({
        reqMethod: 'eshop.goodsSaleWay.getGoodsList',
        params: {
            'mallId' : mallId,
            'saleWay': saleWay,
            'pageNo' : 1,
            'pageSize' : 3,
            'shopId': shopId
        }
    })
}

